import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/api';
import { Position } from '@core/hera-models';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PositionDataService {
  constructor(private apiService: ApiService) {}

  fetchPosition(
    shopId: string,
    positionNumber: string
  ): Observable<Position | null> {
    return this.apiService
      .get(`shops/${shopId}/positions/${positionNumber}`)
      .pipe(catchError(() => of(null)));
  }
}
